import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function Product() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank', 'noopener,noreferrer');
  };
  return <section className="bg-brand-beige py-20 md:py-24 px-5 sm:px-6" data-id="element-631">
      <div className="max-w-5xl mx-auto" data-id="element-632">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-12" data-id="element-633">
          {/* Image */}
          <div className="flex-1 w-full" data-id="element-634">
            <FadeIn data-id="element-635">
              <img src="https://cdn.magicpatterns.com/uploads/fRqZGDUfzvBvZ3MhZduMEC/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-636" />
            </FadeIn>
          </div>

          {/* Text + button */}
          <div className="flex-1 w-full text-center lg:text-left" data-id="element-637">
            <FadeIn delay={0.2} data-id="element-638">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green leading-tight mb-6" data-id="element-639">
                GUÍA COMPLETA: CÓMO VENDER EN AMAZON FBA DESDE CERO (2026)
              </h2>

              <p className="text-lg text-brand-text/80 mb-4 leading-relaxed" data-id="element-640">
                Aprende paso a paso cómo funciona Amazon FBA y cómo comenzar a
                vender productos utilizando la logística de Amazon desde cero.
              </p>
              <p className="text-lg text-brand-text/70 mb-4 leading-relaxed" data-id="element-641">
                Descubre cómo publicar productos correctamente, enviar
                inventario a Amazon, utilizar Seller Central y entender cómo
                funciona el sistema FBA para principiantes.
              </p>
              <p className="text-lg text-brand-text/70 mb-8 leading-relaxed pb-6 border-b border-brand-green/10" data-id="element-642">
                Ideal para personas que desean comenzar un negocio online real
                utilizando la infraestructura y logística de Amazon.
              </p>

              {/* Price above button */}
              <div className="mb-5" data-id="element-643">
                <p className="text-xs font-semibold uppercase tracking-wider text-brand-text/50 mb-1 lg:text-left text-center" data-id="element-644">
                  🔥 HOY SOLO
                </p>
                <p className="text-5xl md:text-6xl font-bold text-brand-green lg:text-left text-center" data-id="element-645">
                  $15.99
                </p>
                <p className="text-xs font-bold text-brand-gold uppercase tracking-wider mt-2 lg:text-left text-center" data-id="element-646">
                  ⚡ Precio de lanzamiento — puede cambiar en cualquier momento
                </p>
              </div>

              <Button onClick={goToCheckout} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-647">
                QUIERO ACCEDER A LA GUÍA
              </Button>
              <div className="flex flex-col sm:flex-row items-center lg:justify-start justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-648">
                <span className="flex items-center gap-1.5" data-id="element-649">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-650" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-651">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-652" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-653">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-654" />
                  COMPRA SEGURA
                </span>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}